<template>
  <section class="px-16 mt-8">
    <loading-flux :value="loadingActions"></loading-flux>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <section class="d-flex flex-column flex-sm-row justify-content-between">
          <h2 class="my-3">Listado de Pagos</h2>
        </section>
      </v-col>
      <v-col cols="12" lg="12" md="12" sm="12" class="pt-0 pb-3">
        <v-btn
          :disabled="loading"
          color="primary"
          small
          outlined
          class="text-white mt-4"
          @click="sendSyncPayments()"
        >
          <i class="mdi mdi-sync me-1"></i>
          Sincronizar Pagos
        </v-btn>
        <v-btn
          class="mt-4 mx-4"
          color="success text-white"
          small
          :disabled="!payments.items.length"
          @click="downloadExcelReportPayments"
        >
          <!-- icon excel -->
          <v-icon small class="mr-1"> mdi-file-excel </v-icon>
          Exportar
        </v-btn>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12" class="mb-2">
        <v-text-field
          label="Búsqueda"
          @input="($event) => getPaymentsData()"
          v-model="filters.filter"
          clearable
          class="mt-3"
          placeholder="Búsqueda"
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <v-autocomplete
          v-model="filters.items"
          class="mt-3"
          @change="($event) => getPaymentsData()"
          :items="[5, 10, 15, 20, 25, 100]"
          label="Items por página"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12">
        <v-autocomplete
          v-model="filters.is_paid"
          class="mt-3"
          @change="($event) => getPaymentsData()"
          :items="listStatusPayment"
          label="Filtrar por Estatus"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" sm="12" class="pt-0 mb-3">
        <v-menu
          ref="menu"
          v-model="datepicker_menu_start"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date_start_formatted"
              prepend-icon="mdi-calendar"
              readonly
              hide-details
              label="Fecha creación"
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="date_start = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.date_start"
            scrollable
            locale="es"
            @input="
              getPaymentsData();
              datepicker_menu_start = false;
            "
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="4" sm="12" class="pt-0 mb-3">
        <v-menu
          ref="menu"
          v-model="datepicker_menu_end"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date_end_formatted"
              prepend-icon="mdi-calendar"
              readonly
              label="Fecha vencimiento"
              v-bind="attrs"
              v-on="on"
              clearable
              hide-details
              @click:clear="date_end = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.date_end"
            scrollable
            locale="es"
            clearable
            @input="
              getPaymentsData();
              datepicker_menu_end = false;
            "
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-2">
        <v-data-table
          :page.sync="filters.page"
          :headers="wrappedTableHeaders"
          :items="payments.items ? payments.items : []"
          item-key="id"
          :items-per-page="filters.items"
          class="elevation-1"
          mobile-breakpoint="993"
          hide-default-footer
          :loading="loading"
          @update:sort-by="updateSortBy"
          @update:sort-desc="updateSortDesc"
          no-data-text="No hay Datos para Mostrar"
          loading-text="Cargando Pagos... Espere Por favor"
        >
          <template v-slot:item.code="{ item }">
            <div class="d-flex align-items-center justify-content-end">
              <v-chip class="primary">
                {{ item.code }}
              </v-chip>
            </div>
          </template>
          <template v-slot:item.business_name="{ item }">
            <div class="text-left">
              {{ item.business_name }}
            </div>
          </template>
          <template v-slot:item.rut="{ item }">
            <div class="text-right">
              {{ item.rut }}
            </div>
          </template>
          <template v-slot:item.project="{ item }">
            <div class="text-left">
              {{ item.project }}
            </div>
          </template>
          <template v-slot:item.amount="{ item }">
            <div class="text-right">
              {{
                item.amount
                  ? `$ ${item.amount.toLocaleString("cl-CL", {
                      currency: "CLP",
                    })}`
                  : 0
              }}
            </div>
          </template>
          <template v-slot:item.issueDate="{ item }">
            <span v-if="item.issueDate != null">{{
              formatDateToHuman(item.issueDate)
            }}</span>
          </template>
          <template v-slot:item.dueDate="{ item }">
            <span v-if="item.dueDate != null">{{
              formatDateToHuman(item.dueDate)
            }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  :color="item.status ? 'green' : 'warning'"
                  v-bind="attrs"
                  v-on="on"
                  class="text-white"
                >
                  {{ item.status ? "Pagada" : "Pendiente" }}
                </v-chip>
              </template>
              <span>{{ item.status ? "Pagada" : "Pendiente" }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="filters.page"
            :length="payments ? payments.total_pages : 1"
            :total-visible="8"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { formatDateMomentToHumanAndAddDay } from "@/helpers/common";
import roles from "@/mixins/roles";
import { authUsuarioComputed } from "@/state/helpers";
import { exportExcelFileFromArrayObjects } from "@/helpers/xlsx";
import moment from "moment";
export default {
  mixins: [roles],
  data() {
    return {
      currentPayment: null,
      loading: false,
      loadingActions: false,
      debounce: null,
      debounceTime: 500,
      datepicker_menu_start: false,
      datepicker_menu_end: false,
      listStatusPayment: [
        {
          text: "Todos",
          value: null,
        },
        {
          text: "Pagada",
          value: true,
        },
        {
          text: "Pendiente",
          value: false,
        },
      ],
      filters: {
        page: 1,
        items: 10,
        filter: "",
        is_paid: null,
        date_start: null,
        date_end: null,
        sort_by: null,
        sort_order: null,
      },
      tableHeaders: [
        {
          value: "code",
          text: "N° de Factura",
          sortable: true,
          align: "end",
          width: "8%",
        },
        {
          value: "issueDate",
          sortable: true,
          align: "center",
          text: "Fecha Factura",
          width: "5%",
        },
        {
          value: "dueDate",
          sortable: true,
          align: "center",
          text: "Fecha Vencimiento",
          width: "10%",
        },
        {
          value: "amount",
          text: "Monto Total",
          sortable: true,
          align: "end",
          width: "8%",
        },
        {
          value: "project",
          text: "Proyecto",
          align: "start",
          sortable: true,
          width: "25%",
        },
        {
          value: "rut",
          text: "RUT",
          align: "end",
          sortable: false,
          width: "10%",
        },
        {
          value: "business_name",
          text: "Razón Social",
          align: "start",
          sortable: false,
          width: "21%",
        },
        {
          value: "status",
          sortable: true,
          align: "center",
          text: "Estado Pago",
          width: "10%",
        },
      ],
    };
  },
  mounted() {
    this.getPaymentsData();
  },
  methods: {
    ...mapActions({
      syncPayments: "payment/syncPayments",
      getAllPayments: "payment/getAllPayments",
    }),
    async sendSyncPayments() {
      this.loading = true;
      const resp = await this.syncPayments();
      if (resp && (resp.status === 200 || resp.status === 201)) {
        this.getPaymentsData();
      } else {
        this.loading = false;
      }
    },
    async getPaymentsData(page = 1) {
      clearTimeout(this.debounce);
      let self = this;
      this.debounce = await setTimeout(async function() {
        self.loading = true;
        self.filters.page = page;
        await self.getAllPayments({
          page,
          general_filter: self.filters.filter ? self.filters.filter : undefined,
          since: self.filters.date_start
            ? `${self.filters.date_start}`
            : undefined,
          since_due: self.filters.date_end
            ? `${self.filters.date_end}`
            : undefined,
          is_paid:
            self.filters.is_paid !== null ? self.filters.is_paid : undefined,
          items: self.filters.items,
          sort_by: self.filters.sort_by ? self.filters.sort_by : undefined,
          sort_order: self.filters.sort_order
            ? self.filters.sort_order
            : undefined,
        });
        self.loading = false;
      }, self.debounceTime);
    },
    async updateSortBy(sortBy) {
      if (sortBy) {
        this.filters.sort_by =
          sortBy == "issueDate"
            ? "initial_date"
            : sortBy == "dueDate"
            ? "due_date"
            : sortBy == "amount"
            ? "total"
            : sortBy == "code"
            ? "folio_number"
            : sortBy == "status"
            ? "is_paid"
            : sortBy;
        this.filters.sort_order = "asc";
        await this.getPaymentsData();
      } else {
        this.filters.sort_by = "created_at";
        this.filters.sort_order = "desc";
        await this.getPaymentsData();
      }
    },
    async updateSortDesc(sortDesc) {
      if (sortDesc) {
        this.filters.sort_order = "desc";
        await this.getPaymentsData();
      }
    },
    formatDateToHuman(date) {
      return formatDateMomentToHumanAndAddDay(date);
    },
    async downloadExcelReportPayments() {
      let self = this;
      this.loadingActions = true;
      const resp = await this.getAllPayments({
        general_filter: self.filters.filter ? self.filters.filter : undefined,
        since: self.filters.date_start
          ? `${self.filters.date_start}`
          : undefined,
        since_due: self.filters.date_end
          ? `${self.filters.date_end}`
          : undefined,
        is_paid:
          self.filters.is_paid !== null ? self.filters.is_paid : undefined,
        items: self.payments.total_items,
        export: true,
      });
      if (resp && resp.status === 200) {
        let payments = resp.data.items.map((item) => {
          let initial_date = new Date(item.initial_date);
          let due_date = new Date(item.due_date);
          return {
            "N° de Factura": item.folio_number,
            "Fecha Factura": new Date(
              initial_date.setDate(initial_date.getDate() + 1)
            ),
            "Fecha Vencimiento": new Date(
              due_date.setDate(due_date.getDate() + 1)
            ),
            "Monto Total": item.total,
            Proyecto: item.project ? item.project.name : "-",
            RUT: item.rut.replace(/C$/, ""),
            "Razón Social": item.name,
            "Estado Pago": item.is_paid ? "Pagado" : "Pendiente",
          };
        });

        this.loadingActions = false;
        return exportExcelFileFromArrayObjects(
          payments,
          "Pagos",
          `listado_pagos_${new Date().toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })}.xlsx`
        );
      }
      if (!resp || resp.status === 400) {
        this.loadingActions = false;
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: resp
            ? resp.data.detail
            : "Ha ocurrido un error en el servidor, por favor intenta nuevamente mas tarde",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      payments: "payment/payments",
    }),
    wrappedTableHeaders() {
      return this.tableHeaders;
    },
    date_start_formatted() {
      if (this.filters.date_start) {
        return moment(this.filters.date_start).format("DD/MM/YYYY");
      }
      return null;
    },
    date_end_formatted() {
      if (this.filters.date_end) {
        return moment(this.filters.date_end).format("DD/MM/YYYY");
      }
      return null;
    },
    minDateEnd() {
      if (this.filters.date_start) {
        return this.filters.date_start;
      }
      return null;
    },
    maxDateStart() {
      if (this.filters.date_end) {
        return this.filters.date_end;
      }
      return null;
    },
  },
  watch: {
    "filters.page"(newValue) {
      this.getPaymentsData(newValue);
    },
  },
};
</script>

<style></style>
